export default __webpack_public_path__ + "static/media/dna.05fff1a1.jpg";